import React from "react";
import lazyPage from "../../../../common/helpers/lazyPage";
import Loader from "../../../components/Loader";

export default lazyPage(
    "src/front/pages/play-plan/DecorationModal/DecorationModal.tsx",
    () => import("./DecorationModal"),
    <Loader margin="auto" />,
);
